export default __webpack_public_path__ + "static/media/C.69d3f51f.svg";